import { useNavigate } from "react-router-dom";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { SchemaRecoverPassword } from "@pages/recover-password/schema/recover-password";

import { useSolicitarRecuperacaoSenha } from "@/hooks/solicitar-recuperacao-senha-usuario";

import Logo from "@/common/assets/png/logo-let-scom.png";

export type SchemaRecoverPasswordType = z.infer<typeof SchemaRecoverPassword>;

const RecoverPassword = () => {
  const { solicitarRecuperacao, isLoading } = useSolicitarRecuperacaoSenha();

  const router = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SchemaRecoverPasswordType>({
    resolver: zodResolver(SchemaRecoverPassword),
  });

  const onSubmit = async (data: SchemaRecoverPasswordType) => {
    solicitarRecuperacao(data.email, {
      onSuccess: (data) => {
        if (data?.code === 200) {
          router("/");
        }

        return;
      },
    });
  };

  return (
    <div className="flex h-screen flex-col lg:flex-row">
      {/* Área de Recuperação */}
      <div className="flex h-full w-full flex-col items-center justify-center bg-gray-100 p-8 lg:w-1/2">
        <img src={Logo} alt="logo" className="mb-8 h-[150px] w-[150px]" />
        <div className="w-full lg:w-1/2">
          <h1 className="mb-2 text-2xl font-bold text-neutral900">Recuperar senha</h1>
          <p className="mb-6 font-sans text-neutral900">
            Informe seu e-mail para receber uma senha nova.
          </p>
        </div>

        <form className="w-full lg:w-1/2" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label className="mb-2 block text-lg font-normal text-neutral900">E-mail:</label>
            <input
              {...register("email")}
              id="email"
              type="email"
              name="email"
              className="focus:shadow-outline mb-3 w-full appearance-none rounded border px-3 py-2 leading-tight text-gray-700 shadow focus:outline-none"
              placeholder="Informe seu e-mail"
            />
            {errors.email && <p className="text-xs italic text-red-500">{errors.email.message}</p>}
          </div>

          <div className="mt-4 flex w-full flex-col items-center justify-center">
            <button
              className="focus:shadow-outline mb-2 w-full rounded bg-neutral900 px-4 py-2 font-bold text-white focus:outline-none"
              type="submit"
            >
              {isLoading ? "Enviando..." : "Enviar"}
            </button>

            <button
              onClick={() => router("/")}
              className="inline-block align-baseline text-sm font-medium text-blue-500 hover:text-blue-800"
            >
              <span className="inline-block align-baseline text-sm font-medium text-blue-500 hover:text-blue-800">
                Voltar
              </span>
            </button>
          </div>
        </form>

        <p className="mt-8 text-xs text-gray-500">Let´scom © 2026 - Todos os direitos reservados</p>
      </div>

      {/* Área de Imagem */}
      <div className="hidden h-full lg:block lg:w-1/2">
        <img
          src="https://media.istockphoto.com/id/1496375910/pt/foto/check-in-using-smartphone-qr-code.jpg?s=2048x2048&w=is&k=20&c=PR20UxjxIamferUw1ZgGfw1hao1APP9WQNLPaOQfEC4="
          alt="Two people shaking hands in a professional setting"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  );
};

export { RecoverPassword };
